<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	import type { PostDTO } from "@hitit/api";
	import ThumbnailImage from "../HubSetting/ThumbnailImage.svelte";
	//Props
	export let item: PostDTO;

	//Constants
	//Variables
	//Functions
	//Do
</script>

<div class="container">
	<Card>
		<div class="content-wrapper">
			<div class="status-box">
				<div class="thumbnail-box">
					<ThumbnailImage editmode={true} imageaddr={item.image} />
				</div>
				<div class="status">
					<div
						class="icon"
						class:publish={item.documentState === "PUBLISHED"}
						class:obsolate={item.documentState === "OBSOLETE"}
					/>
					<p>{item.documentState}</p>
				</div>
			</div>
			<div class="value-wrapper">
				<div class="title-box">
					<span class="title">{$t("mbr.setting.post_setting.title")}</span>
					<span class="value">{item.title}</span>
				</div>
				<div class="title-box">
					<span class="title">{$t("mbr.setting.post_setting.connect_url")}</span
					>
					<span class="value">{item.linkUrl}</span>
				</div>
			</div>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
	}
	.content-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 20px;

		.status-box {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
		.status {
			display: flex;
			align-items: center;
			gap: 10px;
			color: #46474b;
			font-weight: 200;
			font-size: 1rem;
			order: 1;
			.icon {
				width: 15px;
				height: 15px;
				border-radius: 15px;
				background-color: #bcbfc3;

				&.publish {
					background-color: #44e4ae;
				}

				&.obsolate {
					background-color: #ffce00;
				}
			}
			p {
				margin-top: -1px;
			}
		}

		.thumbnail-box {
			display: flex;
			order: 2;
		}

		.value-wrapper {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
		.title-box {
			display: flex;
			flex-direction: column;
			gap: 10px;
			.title {
				font-size: 1rem;
				color: #6d6f76;
			}
			.value {
				word-break: break-all;
				font-size: 1rem;
				font-weight: 500;
				line-height: 22px;
				color: #46474b;
			}
		}
	}

	@include DesktopSize {
		.content-wrapper {
			.status-box {
				flex-direction: row;
				justify-content: space-between;
				align-items: flex-start;
				gap: unset;
			}
			.status {
				font-size: 1.25rem;
				order: unset;
				.icon {
					width: 20px;
					height: 20px;
					border-radius: 20px;
				}
				p {
				margin-top: -2px;
			}
			}

			.thumbnail-box {
				order: unset;
			}

			.title-box {
				.value {
					font-size: 1.25rem;
					line-height: 25px;
				}
			}
		}
	}
</style>
